export enum CitizenType {
  ZambianCitizen = 'Zambian Citizen',
  ForeignCitizen = 'Foreign Citizen',
}
